import AdministrationOverviewView from "@/administration/views/AdministrationOverviewView.vue";
import AdministrationGroupsView from "@/administration/views/AdministrationGroupsView.vue";
import AdministrationGroupView from "@/administration/views/AdministrationGroupView.vue";
import AdministrationContainersView from "@/administration/views/AdministrationContainersView.vue";
import AdministrationContainerView from "@/administration/views/AdministrationContainerView.vue";
import {RightService} from "@/services/RightService";

// Module réservé au super admin (le back refuse de toute façon les autres rôles)
const superAdminOnly = () => (RightService.isSuperAdmin() ? true : {path: "/"});

export const administrationRoutes = [
  {
    path: "/administration",
    name: "AdministrationOverview",
    component: AdministrationOverviewView,
    beforeEnter: superAdminOnly,
  },
  {
    path: "/administration/groups",
    name: "AdministrationGroups",
    component: AdministrationGroupsView,
    beforeEnter: superAdminOnly,
  },
  {
    path: "/administration/groups/:id",
    name: "AdministrationGroup",
    component: AdministrationGroupView,
    beforeEnter: superAdminOnly,
  },
  {
    path: "/administration/containers",
    name: "AdministrationContainers",
    component: AdministrationContainersView,
    beforeEnter: superAdminOnly,
  },
  {
    path: "/administration/containers/:id",
    name: "AdministrationContainer",
    component: AdministrationContainerView,
    beforeEnter: superAdminOnly,
  },
];
